import { APP_STORE_URL } from "../config/app";
import { LINKS } from "./site";
import { PROGRAMS } from "./programs";

export const SITE = "https://jakeferree.com";
const og = (p) => `${SITE}/media/og/${p.replace(/\.[A-Za-z]+$/, ".jpg")}`;
const PORTRAIT = og("6a11e211086f311fc02b485c/1779556881318/DD9380E5-FEB3-4197-877B-7CC061584F27.PNG");

const PERSON = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Jake Ferree",
  url: `${SITE}/`,
  image: PORTRAIT,
  jobTitle: "Yoga instructor, breathwork guide, massage therapist and meditation teacher",
  worksFor: { "@type": "Organization", name: "Feeling Moved" },
  address: { "@type": "PostalAddress", addressLocality: "San Diego", addressRegion: "CA", addressCountry: "US" },
  sameAs: [LINKS.instagram, LINKS.youtube],
};

const BUSINESS = {
  "@context": "https://schema.org",
  "@type": "HealthAndBeautyBusiness",
  name: "Feeling Moved",
  url: `${SITE}/`,
  image: PORTRAIT,
  founder: { "@type": "Person", name: "Jake Ferree" },
  address: { "@type": "PostalAddress", addressLocality: "San Diego", addressRegion: "CA", addressCountry: "US" },
  areaServed: ["San Diego, CA", "Online"],
  sameAs: [LINKS.instagram, LINKS.youtube],
  makesOffer: ["Yoga classes", "Private yoga sessions", "Breathwork", "Meditation", "Massage & Bodywork", "Hypnotherapy", "Retreats & events", "Online yoga video library"].map((name) => ({
    "@type": "Offer",
    itemOffered: { "@type": "Service", name },
  })),
};

const APP = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Yoga Sutras: Presence Revealed",
  applicationCategory: "HealthApplication",
  operatingSystem: "iOS",
  description:
    "Explore the Yoga Sutras through clear, accessible teachings, guided meditations and embodied practice. Yoga Sutras: Presence Revealed brings each sutra into everyday life, helping you move beyond understanding the teachings to experiencing them.",
  author: { "@type": "Person", name: "Jake Ferree" },
  url: `${SITE}/yoga-sutras-app`,
  downloadUrl: APP_STORE_URL,
  installUrl: APP_STORE_URL,
  sameAs: [APP_STORE_URL],
};

export const SEO = {
  "/": {
    title: "Jake Ferree | San Diego & Online Yoga, Breathwork, Massage, Meditation & Hypnosis",
    description: "Jake Ferree is a San Diego yoga instructor, Tonal coach and wellness guide offering yoga classes, breathwork, meditation, nervous system regulation, somatic coaching, massage, retreats and online wellness and yoga programs.",
    image: PORTRAIT,
    jsonld: [PERSON, BUSINESS],
  },
  "/work-with-me": {
    title: "Work With Jake Ferree | Yoga, Breathwork, Massage & Hypnosis — FEELING MOVED",
    description: "Explore private sessions and wellness services with Jake Ferree, including yoga, breathwork, massage therapy, meditation, hypnosis, nervous system regulation and embodied support in San Diego and online.",
    image: og("6a11e4b170b34345038b8e9c/1779557553718/DD9380E5-FEB3-4197-877B-7CC061584F27.PNG"),
  },
  "/private-sessions": {
    title: "Private Yoga, Massage, Breathwork & Wellness Sessions | Jake Ferree — FEELING MOVED",
    description: "Book private sessions with Jake Ferree in San Diego or online. Personalized yoga, breathwork, meditation, hypnosis and nervous system support designed to help you feel grounded, connected and more present in your body.",
    image: og("6a11ec0b3fda827df9cbb0aa/1779559435025/DDFD878E-63CA-435E-85E1-60A3CDCF314D+2.PNG"),
  },
  "/massage-bodywork": {
    title: "Massage & Bodywork in San Diego | Jake Ferree – FEELING MOVED",
    description: "Experience massage and bodywork sessions with Jake Ferree in San Diego. Blending therapeutic massage, Thai bodywork, breathwork, movement and nervous system support to help you feel grounded, open and more connected to your body.",
    image: og("6a11eb3370b34345038b92c3/1779559219140/65836A64-D36C-4AE6-A1FC-886781472774.PNG"),
  },
  "/classes": {
    title: "Yoga & Breathwork Classes in San Diego & Online | Jake Ferree — FEELING MOVED",
    description: "Join yoga, breathwork, meditation and mindful movement classes with Jake Ferree in San Diego and online. Explore grounding practices designed to help you feel better in your body and more present in your life.",
    image: og("6a11e55070b34345038b8f08/1779557712338/DD9380E5-FEB3-4197-877B-7CC061584F27.PNG"),
  },
  "/practice-online": {
    title: "Online Yoga, Breathwork & Meditation Classes | Jake Ferree — FEELING MOVED",
    description: "Jake Ferree is a San Diego-based yoga instructor, breathwork guide and wellness practitioner with over 20 years of experience. He has taught on platforms including Tonal and Xbox Fitness, where he created the Yo30 yoga series, and now offers online classes, private sessions and embodied wellness experiences through Feeling Moved.",
    image: og("6a11e73a086f311fc02b4ba4/1779558202968/7B4B15E3-B628-4EBF-8E30-386EBD9B863B.PNG"),
  },
  "/yoga-sutras-app": {
    title: "Yoga Sutras: Presence Revealed | Meditation & Practice App — FEELING MOVED",
    description: APP.description,
    image: og("6abf37838a8e3265927274f5/1790916483695/987FA242-EE5C-432C-9EFB-F6F2309821FB.PNG"),
    jsonld: [APP],
  },
  "/yoga-sutras-workshops": {
    title: "Yoga Sutras Workshops & Teacher Trainings · Jake Ferree",
    description: "An experiential approach to the Yoga Sutras through discussion, reflection, meditation and practical application — workshops and teacher trainings with Jake Ferree.",
    image: PORTRAIT,
  },
  "/jakeferree-bio": {
    title: "About Jake Ferree | San Diego Yoga, Breathwork & Wellness Guide — FEELING MOVED",
    description: "Learn more about Jake Ferree, a San Diego-based yoga instructor, breathwork guide, massage therapist and meditation teacher offering embodied wellness experiences, nervous system support, private sessions and online classes.",
    image: og("6a11e2929bbeeb1bb6178f16/1779557010787/DD9380E5-FEB3-4197-877B-7CC061584F27.PNG"),
  },
  "/retreatsandevents": {
    title: "Yoga Retreats & Wellness Events | Jake Ferree — FEELING MOVED",
    description: "Explore upcoming yoga retreats, wellness events, breathwork experiences, meditation gatherings and embodied workshops with Jake Ferree in San Diego and beyond.",
    image: og("6a11e84c086f311fc02b4c6c/1779558476258/EE484850-9CD6-4F65-87FC-EC7B9C0574E6.PNG"),
  },
  "/contact": {
    title: "Contact Jake Ferree | Private Sessions, Yoga, Meditation, Massage, Breathwork, Hypnosis & Wellness — FEELING MOVED",
    description: "Reach out to Jake Ferree for private yoga sessions, breathwork, massage therapy, meditation, hypnosis, wellness events and online offerings in San Diego and beyond.",
    image: og("6a11e8e33fda827df9cbae68/1779558627022/DD9380E5-FEB3-4197-877B-7CC061584F27.PNG"),
  },
  "/connect": {
    title: "Jake Ferree | Yoga, Breathwork & Bodywork in San Diego | FEELING MOVED",
    description: "Explore FEELING MOVED with Jake Ferree — yoga, breathwork, meditation, bodywork, retreats, online classes and nervous system support in San Diego. Move better, feel better and reconnect to presence.",
    image: og("6a1369659bbeeb1bb61862e1/1779657061363/DD9380E5-FEB3-4197-877B-7CC061584F27.PNG"),
  },
  "/yoga-sutras-presence-revealed-privacy-policy": {
    title: "Yoga Sutras: Presence Revealed - Privacy Policy — FEELING MOVED",
    description: "Privacy Policy for the Yoga Sutras: Presence Revealed mobile application.",
    image: PORTRAIT,
  },
  "/guided-programs": {
    title: "Guided Yoga & Meditation Programs | Jake Ferree — FEELING MOVED",
    description: "Structured yoga and meditation programs with Jake Ferree, from Yoga for Beginners in 21 Days to 31 days of meditation. Build consistency, deepen your practice and experience lasting change.",
    image: `${SITE}${PROGRAMS[0].image}`,
  },
  ...Object.fromEntries(
    PROGRAMS.map((p) => [
      `/guided-programs/${p.slug}`,
      {
        title: `${p.displayTitle}${p.subtitle ? ` · ${p.subtitle}` : ""} | Guided Program with Jake Ferree — FEELING MOVED`,
        description: p.about[0].length > 158 ? `${p.about[0].slice(0, 155).replace(/\s+\S*$/, "")}…` : p.about[0],
        image: `${SITE}${p.image}`,
      },
    ]),
  ),
};
